<template>
  <div class="datepicker-mobile">
    <div class="placeholder-container" :class="{'error': errorInput}">
      <input
        type="date"
        placeholder=" "
        name="datepicker"
        id="datepicker"
        class="calendarInp inputCal"
        :class="{ 'acceptInp': acceptInput }"
        @input="onInput($event.target.value)"
        @focus="onFocus"
        @focusout="onFocusOut"
        :value="value_"
        :min="minDate_"
        :max="maxDate_" />
      <label for="datepicker">{{ placeholder }}</label>
      <div class="error-input-message" v-if="errorInput">
        <slot name="mobile-invalid-input-error">
          {{ $t('qic_error_empty_input') }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
export default {
  name: 'DatePickerMobile',
  props: {
    value: {},
    minDate: {},
    maxDate: {},
    placeholder: { type: String, default: '' },
    validation: {},
    defaultDateToSet: {}
  },
  data () {
    return {
      formatString: 'yyyy-MM-dd',
      isFocused: false
    }
  },
  computed: {
    errorInput () {
      return this.validation?.$dirty && this.validation?.$invalid
    },
    acceptInput () {
      if (!this.validation) return false
      return !this.validation?.$invalid
    },
    locale () {
      return this.$i18n.locale
    },
    value_ () {
      return this.formatDate(this.value || (this.isFocused ? this.defaultDateToSet : null))
    },
    minDate_ () {
      return this.minDate ? format(this.minDate, 'yyyy-MM-dd') : ''
    },
    maxDate_ () {
      return this.maxDate ? format(this.maxDate, 'yyyy-MM-dd') : ''
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value && new Date(value))
    },
    formatDate (date) {
      return date && format(date, 'yyyy-MM-dd')
    },
    onFocus () {
      this.isFocused = true
    },
    onFocusOut () {
      this.isFocused = false
    }
  },
  mounted () {
    if (/Android/i.test(navigator.userAgent)) {
      const pickerMobile = document.querySelector('.datepicker-mobile')
      pickerMobile.classList.add('android')
    }
  }
}
</script>
<style lang="scss" scoped>
  .error-input-message {
    color: #ef3030;
    font-size: 12px;
    line-height: 1;
    margin-top: 8px;
  }
  .android .inputCal{
    padding: 30px 50px 20px 15px !important;
  }
  .rtl{
    .android .inputCal{
      padding: 30px 15px 20px 50px !important;
    }
  }
</style>
